export default "__VITE_ASSET__DWqz6er8__"